import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const isHomePage = window.location.pathname === '/' || window.location.pathname === '';
  const navLinks = [{
    name: 'Results',
    href: isHomePage ? '#results' : '/results'
  }, {
    name: 'How It Works',
    href: isHomePage ? '#how-it-works' : '/how-it-works'
  }, {
    name: 'Pricing',
    href: isHomePage ? '#pricing' : '/pricing'
  }, {
    name: 'Blog',
    href: '/blog'
  }, {
    name: 'FAQ',
    href: isHomePage ? '#faq' : '/faq'
  }];
  const serviceLinks = [{
    name: 'Electricians',
    href: '/services/electrician-website-dublin'
  }, {
    name: 'Restaurants',
    href: '/services/restaurant-website-dublin'
  }, {
    name: 'Barbers',
    href: '/services/barber-website-dublin'
  }, {
    name: 'Trades',
    href: '/services/trades-website-dublin'
  }, {
    name: 'Hotels',
    href: '/services/hotel-website-ireland'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      // Anchor scroll on home page — default behavior
      return;
    }
    // Route navigation
    e.preventDefault();
    window.history.pushState({}, '', href);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
    setIsMobileMenuOpen(false);
    setIsServicesOpen(false);
  };
  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.history.pushState({}, '', '/');
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
  };
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'backdrop-blur-md border-b border-[#c9a84c]/20 py-3' : 'py-5'}`} style={{
    backgroundColor: isScrolled ? 'rgba(5, 5, 5, 0.92)' : 'transparent'
  }} data-id="element-307">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-308">
        <a href="/" onClick={handleLogoClick} className="text-2xl font-bold tracking-tight" style={{
        fontFamily: "'Space Grotesk', sans-serif"
      }} data-id="element-309">
          <span className="text-white" data-id="element-310">ai</span>
          <span className="text-[#c9a84c]" data-id="element-311">.</span>
          <span className="text-white" data-id="element-312">web</span>
        </a>

        <nav className="hidden md:flex items-center space-x-8" data-id="element-313">
          {/* Services Dropdown */}
          <div className="relative group" data-id="element-314">
            <button className="flex items-center space-x-1 text-sm text-white/80 hover:text-[#c9a84c] transition-colors focus:outline-none" data-id="element-315">
              <span data-id="element-316">Services</span>
              <ChevronDown className="w-4 h-4" data-id="element-317" />
            </button>
            <div className="absolute top-full left-0 mt-2 w-48 bg-[#0a0a0a] border border-white/10 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform origin-top-left" data-id="element-318">
              <div className="py-2" data-id="element-319">
                {serviceLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="block px-4 py-2 text-sm text-white/70 hover:text-[#c9a84c] hover:bg-white/5" data-id="element-320">
                    {link.name}
                  </a>)}
              </div>
            </div>
          </div>

          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-sm text-white/80 hover:text-[#c9a84c] transition-colors" data-id="element-321">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden md:flex items-center space-x-4" data-id="element-322">
          <div className="px-3 py-1 rounded-full border border-[#c9a84c]/50 bg-[#c9a84c]/10" data-id="element-323">
            <span className="text-xs font-medium text-[#c9a84c]" data-id="element-324">
              Dublin Offer • €249
            </span>
          </div>
          <a href={isHomePage ? '#contact' : '/contact'} onClick={e => handleNavClick(e, isHomePage ? '#contact' : '/contact')} className="px-5 py-2 border border-[#c9a84c] text-[#c9a84c] rounded-md hover:bg-[#c9a84c] hover:text-black transition-all duration-300 text-sm font-medium" data-id="element-325">
            Contact
          </a>
        </div>

        <button className="md:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-326">
          {isMobileMenuOpen ? <X data-id="element-327" /> : <Menu data-id="element-328" />}
        </button>
      </div>

      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 border-b border-white/10 p-4 flex flex-col space-y-4 shadow-2xl h-[calc(100vh-80px)] overflow-y-auto" style={{
      backgroundColor: '#0a0a0a'
    }} data-id="element-329">
          {/* Mobile Services Menu */}
          <div data-id="element-330">
            <button onClick={() => setIsServicesOpen(!isServicesOpen)} className="flex items-center justify-between w-full text-white/80 hover:text-[#c9a84c] py-2" data-id="element-331">
              <span data-id="element-332">Services</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isServicesOpen ? 'rotate-180' : ''}`} data-id="element-333" />
            </button>
            {isServicesOpen && <div className="pl-4 space-y-2 mt-2 border-l border-white/10 ml-2" data-id="element-334">
                {serviceLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="block text-sm text-white/60 hover:text-[#c9a84c] py-1" data-id="element-335">
                    {link.name}
                  </a>)}
              </div>}
          </div>

          {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/80 hover:text-[#c9a84c] py-2 block" onClick={e => handleNavClick(e, link.href)} data-id="element-336">
              {link.name}
            </a>)}
          <div className="pt-4 border-t border-white/10 flex flex-col space-y-4" data-id="element-337">
            <span className="text-center text-xs font-medium text-[#c9a84c] border border-[#c9a84c]/30 rounded-full py-1" data-id="element-338">
              Dublin Offer • €249
            </span>
            <a href={isHomePage ? '#contact' : '/contact'} className="w-full text-center px-5 py-3 bg-[#c9a84c] text-black rounded-md font-medium" onClick={e => {
          handleNavClick(e, isHomePage ? '#contact' : '/contact');
          setIsMobileMenuOpen(false);
        }} data-id="element-339">
              Contact Us
            </a>
          </div>
        </div>}
    </header>;
}